import { motion } from "framer-motion";
import { FC, useContext, useEffect, useRef, useState } from "react";

import "../../../css/ImageWithSpinAnimation.css"
import { ImagePageContext } from "../../CreateContext";

type Props={
    Img:string[]
    Title:string
    CardWidth:number
}

export const ImageWithSpinAnimation:FC<Props> = (props)=>{
    
    const { Img, Title, CardWidth} =props
    const elementRef = useRef<HTMLDivElement>(null);
    const [ImageSize, setImageSize] = useState<({ height: string; width: string })>({ height: '', width: '' });
    const { ImagePage, setPage } = useContext(ImagePageContext)
    const [pageNumber, setPageNumber] = useState(ImagePage.page)
    const page = ImagePage.page
    const direction = ImagePage.direction

    const swipeConfidenceThreshold = 10000;
    let timerId:  NodeJS.Timer| undefined;

    const TimerStart =()=>{
        timerId = setTimeout(()=>{
          autoPaginate(1);
      },10000) //10秒に一回カードが入れ替わる
    }

    useEffect(() => {
      // 1枚目のカードの大きさにsizeを揃える
      const loadCardImageSize = async () => {

            const img = new Image();
            img.src = Img[0];
            await new Promise<void>((resolve) => {
              img.onload = () => {
                const cardWidth = CardWidth ;
                const cardHeight = cardWidth * img.height / img.width;
                setImageSize({ width: `${cardWidth}px`, height: `${cardHeight}px` });
                resolve();
              };
            });
      };
      loadCardImageSize();
    },[])


     useEffect(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if(entry.intersectionRatio < 0.6 && entry.intersectionRatio > 0.4){ //コンテンツが半分見えた時の処理
                if(entry.target.classList.length ==0){ //　要素にcssが適用されていない時
                  entry.target.classList.add('flipLeft');
                  if (Img.length != 1){
                    TimerStart();
                  }
                }
              }else if(entry.intersectionRatio < 0.2) { //コンテンツが画面から消える時の処理
                if(entry.target.classList.length ==1){ //　要素にcssが適用されている時
                  entry.target.classList.remove('flipLeft');
                  clearTimeout(timerId);
                }
              }
            }
          });
        },{ threshold: [0.1, 0.5] } // 画面が半分と少し表示された時に走る
      );

      if (elementRef.current) {
        observer.observe(elementRef.current);
      }
      return () => {
      if (elementRef.current) {
        observer.unobserve(elementRef.current);
      }
      };
    }, [ImageSize, pageNumber]);

    const swipePower = (offset: number, velocity: number) => {
      return Math.abs(offset) * velocity;
    };
  
    const imageIndex = (page: number) => {
      return (page % Img.length + Img.length) % Img.length;
    };
  
    const paginate = (newDirection: number) => {
      // setPage([page + newDirection, newDirection]);
      setPage({page:page + newDirection,direction:newDirection})
    };

    const autoPaginate = (newDirection: number) => {
      // setPage([page + newDirection, newDirection]);
      setPage({page:page + newDirection ,direction:newDirection})
      setPageNumber(pageNumber + newDirection)
    };

    if (!ImageSize.width || !ImageSize.height) {
    return null; // 読み込み中の場合は何も表示しない
      }else{
    return(
    <div ref={elementRef}>
      <motion.img
      className="flipLeft"
      alt={`${Title} `}
      style={{ width: ImageSize.width,
              height: ImageSize.height,
              objectFit: 'cover'}} 
      key={page}
      src={Img[imageIndex(page)]}
      custom={direction}
      initial="enter"
      animate="center"
      exit="exit"
      transition={{
        x: { type: 'spring', stiffness: 300, damping: 30 },
        opacity: { duration: 0.2 },
      }}
      drag="x"
      dragConstraints={{ left: 0, right: 0 }}
      dragElastic={1}
      onDragEnd={(e, { offset, velocity }) => {
        const swipe = swipePower(offset.x, velocity.x);
    
        if (swipe < -swipeConfidenceThreshold) {
          paginate(1);
        } else if (swipe > swipeConfidenceThreshold) {
          paginate(-1);
        }
      }}
    />
      </div>
    )
}}